module.exports = __webpack_public_path__ + "static/media/pt-sankei-dharma-indonesia.da5ad4c0.jpg";